import React, {
  FC,
  ReactElement,
  HTMLAttributes,
  PropsWithChildren,
} from "react";
import { cn } from "helpers/style";
import styles from "./Container.module.scss";

type Props = PropsWithChildren<HTMLAttributes<HTMLDivElement>>;

const Container: FC<Props> = ({ children, className }): ReactElement => {
  return <div className={cn([styles.container, className])}>{children}</div>;
};

export default Container;
